<script setup>
import { ref, reactive, watch, provide } from 'vue';
import { api } from '/app/plugins/services';

const props = defineProps({
    platform: String,
});

const emit = defineEmits(['loaded']);

const olympiads = reactive({
    bases: [],
    publics: [],
    privates: [],
});

const process = ref(null);
const busy = ref(false);

provide('olympiads', olympiads);

async function fetch() {
    try {
        busy.value = true;

        const { data: response } = await api.olympiad.bases(props.platform);

        olympiads.bases = response.data;

        emit('loaded', { olympiads });

        return response.data;
    } finally {
        busy.value = false;
        process.value = null;
    }
}

watch(() => props.platform, (value) => {
    if (value) {
        fetch();
    }
});
</script>

<template>
    <slot />
</template>
